// import mockGetProposta from '~/Pages/Vendas/mockGetProposta.json';
import * as api from '~/Services/Service';
import {
  BOLETO,
  CHEQUE,
  CARTAO,
  CondicoesEspeciaisStatus,
  PeriodicidadeBalao,
} from '~/constant';

import { salvarSinal, adicionaFormaPgtoEntrada } from './Sinal/actions';
import {
  adicionarParcelaFinanciamento,
  aplicarDescontoSetclub,
} from './Financiamento/actions';
import { setDataVenda, setCodigoPontoVenda } from './Checkout/actions';
import { dividirComissao } from './DivisaoComissao/actions';
import { createDate } from '~/Utils/Helpers';
import { adicionaFormaPgtoEntradaImob } from './SinalMesa/actions';

export const selecionaAtivo = codigoAtivo => ({
  type: '@vendas/SELECIONA_ATIVO',
  payload: {
    codigoAtivo,
  },
});

export const selecionaTabelaPreco = codigoTabela => (dispatch, getState) => {
  const tabela = getState().vendas.tabelasPorCodigo[codigoTabela];
  dispatch(setTabelaPreco(tabela));
};

export const setTabelaPreco = tabela => ({
  type: '@vendas/SELECIONA_TABELA_PRECO',
  payload: {
    codigoTabela: tabela.codigo,
    ativos: tabela.ativos,
  },
});

export const selecionaConstrutor = codigo => ({
  type: '@vendas/SELECIONA_CONSTRUTOR',
  payload: {
    codigoConstrutor: codigo,
  },
});

export const setConstrutor = codigo => ({});

export const carregarPropostaInicial = (
  codigoFamilia,
  idProspecto // criptografado
) => async dispatch => {
  dispatch(carregandoProposta());

  try {
    const propostaInicial = await api.obterPropostaInicial(
      codigoFamilia,
      idProspecto
    );
    dispatch(setPropostaInicial(propostaInicial));
  } catch (err) {
    console.error(err);
    dispatch(erroCarregarProposta(err.message || 'Proposta não encontrada'));
  }
};

const setPropostaInicial = proposta => ({
  type: '@vendas/PROPOSTA_CARREGADA',
  payload: {
    proposta: proposta,
  },
});

const carregandoProposta = () => ({
  type: '@vendas/CARREGANDO_PROPOSTA',
});

const erroCarregarProposta = message => ({
  type: '@vendas/ERRO_CARREGAR_PROPOSTA',
  payload: message,
});

export const carregarPropostaAuxiliar = codigoProposta => async dispatch => {
  dispatch(carregandoProposta());

  try {
    const response = await api.buscarPropostaAuxiliar(codigoProposta);
    dispatch(setPropostaInicial(response.proposta_inicial));
    const gravada = response.proposta_gravada;
    dispatch(
      setCondicoesEspeciais(response.proposta_gravada.condicoes_especiais)
    );

    // selecionar tabela
    const tabela = response.proposta_inicial.empreendimento.tabelas.find(
      tab => tab.codigo === gravada.tabela_selecionada
    );
    if (!tabela) {
      const msg = `A tabela (${gravada.tabela_selecionada}) que foi usada na venda gravada foi inativada`;
      dispatch(erroCarregarProposta(msg));
      return msg;
    }
    dispatch(setTabelaPreco(tabela));
    // adicionar ativo e configurar os valores

    for (const ativo of gravada.ativos) {
      const {
        codigo,
        valor_sinal,
        valor_venda,
        valor_sinal_incorporadora,
        valor_sinal_imobiliaria,
        desconto,
      } = ativo;
      const {
        sinal: desconto_sinal,
        valor_venda: desconto_valor_venda,
        aplicou_cheque_bonus_sinal,
        aplicou_cheque_bonus_valor_venda,
        codigo_solicitacao_desconto,
      } = desconto || {};

      dispatch(selecionaAtivo(codigo));
      dispatch(
        salvarSinal({
          codigo,
          valor_sinal, // Sinal total, com desconto (se tiver)
          valor_sinal_imobiliaria,
          valor_sinal_incorporadora,
          valor_venda,
          desconto_sinal,
          desconto_valor_venda,
          aplicou_cheque_bonus_sinal,
          aplicou_cheque_bonus_valor_venda,
          codigo_solicitacao_desconto,
        })
      );
    }

    // adicionar parcelas sinal
    for (const parcela of gravada.sinal) {
      dispatch(
        adicionaFormaPgtoEntrada({
          ...parcela,
          qtdParcelas: 1,
          vencimento: createDate(parcela.vencimento),
        })
      );
    }
    for (const parcela of gravada.sinal_mesa) {
      dispatch(
        adicionaFormaPgtoEntradaImob({
          ...parcela,
          qtdParcelas: 1,
          vencimento: createDate(parcela.vencimento),
        })
      );
    }

    // adicionar parcelas de financiamento
    for (const ativo of gravada.ativos) {
      const {
        valorPresente,
        valor,
        vencimento,
        quantidade_parcelas,
      } = ativo.financiamento;

      //AQUI PEGA AS CONDICIONANTES E ADICIONA NO OBJETO FINAL
      ativo.parcelas_condicionantes.forEach(item => {
        // W-0981 SetClub: a condicionante de balão 3 É o desconto SetClube.
        // Ela é reidratada no campo dedicado `descontoSetclub` e NÃO entra em
        // `parcelasFinanciamento` — representação única, igual ao que o botão
        // SetClube produz. Sem isso a parcela existiria nos dois lugares e o
        // `gravarVenda` a enviaria duplicada ao backend.
        if (Number(item.periodicidade_balao) === PeriodicidadeBalao.SetClube) {
          dispatch(
            aplicarDescontoSetclub(
              ativo.codigo,
              item.valor_presente,
              item.vencimento
            )
          );
          return;
        }

        dispatch(
          adicionarParcelaFinanciamento(
            ativo.codigo,
            item.valor_presente,
            item.valor,
            item.vencimento,
            item.codigo_intermediaria,
            1,
            1, //numeroDaParcela
            false, //tipoParcelaEscadinha
            item.periodicidade_balao //tipoBalao
          )
        );
      });

      //AQUI PEGA AS INTERMEDIARIAS E ADICIONA NO OBJETO FINAL
      if (ativo.parcelas_intermediarias.length > 0) {
        ativo.parcelas_intermediarias.forEach((item, index) => {
          dispatch(
            adicionarParcelaFinanciamento(
              ativo.codigo, //codigoAtivo
              item.valor_presente, //valorPresente
              item.valor, //valor
              item.vencimento, // vencimento
              BOLETO, //tipo
              1, //parcelas
              index + 1, //numeroDaParcela
              null, //tipoParcelaEscadinha
              null, //tipoBalao
              null, //taxa
              true // tipoIntermediaria
            )
          );
        });
      }

      if (ativo.parcelas_em_series) {
        var numeroDaParcela = 1;
        //Parcelas em séries
        ativo.parcelas_em_series.forEach(item => {
          dispatch(
            adicionarParcelaFinanciamento(
              ativo.codigo,
              item.valor_presente,
              item.valor,
              item.vencimento,
              BOLETO,
              1,
              numeroDaParcela,
              true //tipoParcelaEscadinha
            )
          );
          numeroDaParcela++;
        });
      }

      dispatch(
        adicionarParcelaFinanciamento(
          ativo.codigo,
          valorPresente,
          valor,
          vencimento,
          BOLETO,
          quantidade_parcelas
        )
      );

      if (ativo.divisao_comissao) {
        dispatch(
          dividirComissao({
            ...ativo.divisao_comissao,
            codigo: ativo.codigo,
          })
        );
      }
    }

    dispatch(setDataVenda(createDate(gravada.data)));
    dispatch(setCodigoPontoVenda(gravada.codigo_ponto_venda));

    return true;
  } catch (err) {
    const msg = err.message || 'Proposta não encontrada';
    console.error(err);
    dispatch(erroCarregarProposta(msg));
    return msg;
  }
};

export const setProspectoVenda = () => (dispatch, getState) => {
  const prospecto = getState().prospecto.detail;

  dispatch({
    type: '@vendas/SET_PROSPECTO',
    payload: {
      prospecto,
    },
  });
};

/**
 * W-0981: `condicoesEspeciais` entra no Redux por dois caminhos que nomeiam o
 * MESMO fato de formas diferentes — o fluxo de criação manda `isIsencao`
 * (Formik do ModalCondicoesEspeciais) e a proposta gravada manda `is_isencao`
 * (SnakeCaseNamingStrategy do WebAPI). Quem lia só uma das formas ficava cego:
 * na revisão/aprovação o motivo de condição especial não era empilhado e a tela
 * mostrava "Sua venda não precisa de autorização".
 *
 * Forma canônica no state: `isIsencao` (camelCase, como o resto do state) e os
 * sub-objetos `financiamento` / `saldo_correcao` / `valor_lote` sempre
 * presentes. As chaves internas seguem snake_case porque é assim que a API as
 * emite e que os consumidores já as leem; o snake_case do flag volta só no
 * payload de `gravarVenda`.
 *
 * Idempotente: reaplicar sobre a própria saída não muda nada.
 *
 * @param {object} condicoes forma camelCase (criação) ou snake_case (API)
 */
export const normalizarCondicoesEspeciais = condicoes => {
  // "Sem condição especial" tem várias representações vivas: `[]` (estado
  // inicial do reducer), `null`/`undefined` (API) e `{}`. Vários consumidores
  // testam isso com `Object.keys(...).length > 0`, então a forma vazia precisa
  // atravessar intacta.
  if (!condicoes || typeof condicoes !== 'object') return condicoes;
  if (Array.isArray(condicoes)) return condicoes;
  if (Object.keys(condicoes).length === 0) return condicoes;

  const { is_isencao, isIsencao, ...resto } = condicoes;

  return {
    ...resto,
    isIsencao: !!(isIsencao || is_isencao),
    financiamento: resto.financiamento || {},
    saldo_correcao: resto.saldo_correcao || {},
    valor_lote: resto.valor_lote || {},
  };
};

export const setCondicoesEspeciais = novasCondicoes => async dispatch => {
  dispatch({
    type: '@vendas/SET_CONDICOES_ESPECIAIS',
    payload: {
      // `|| 0` preservado: `Object.keys(0).length === 0` é o sentinela de
      // "vazio" que Pages/Vendas/helpers.js e ModalSinal já usam.
      condicoesEspeciais: normalizarCondicoesEspeciais(novasCondicoes) || 0,
    },
  });
};
export const setTravarVenda = travarVenda => async dispatch => {
  dispatch({
    type: '@vendas/SET_TRAVAR_VENDA',
    payload: {
      travarVenda: travarVenda,
    },
  });
};

export const setVendaInterna = isVendaInterna => async dispatch => {
  dispatch({
    type: '@vendas/SET_VENDA_INTERNA',
    payload: {
      vendaInterna: isVendaInterna,
    },
  });
};
export const setParcelasNaoConcomitantes = isNaoConcomitantes => async dispatch => {
  dispatch({
    type: '@vendas/SET_PARCELAS_NAO_CONCOMITANTES',
    payload: {
      isParcelasNaoConcomitantes: isNaoConcomitantes || false,
    },
  });
};
export const gravarVenda = (checkoutData, codigoProposta = null) => async (
  dispatch,
  getState
) => {
  dispatch({
    type: '@vendas/GRAVANDO_VENDA',
  });
  const state = getState().vendas;
  const condicoes = getState().vendas.condicoesEspeciais;
  const isParcelasNaoConcomitantes = getState().vendas
    .isParcelasNaoConcomitantes;

  let condicoesEspeciais = {};
  if (condicoes.descricao) {
    condicoesEspeciais = {
      financiamento: {
        avaliacao_bancaria:
          condicoes && condicoes.financiamento.avaliacao_bancaria,
        prazo_financiamento_meses:
          condicoes && condicoes.financiamento.prazo_financiamento_meses,
        data_prazo_financiamento:
          condicoes && condicoes.financiamento.data_prazo_financiamento,
        data_termino_construcao:
          condicoes && condicoes.financiamento.data_termino_construcao,
      },
      saldo_correcao: {
        data_saldo: condicoes && condicoes.saldo_correcao.data_saldo,
        indice_correcao: condicoes && condicoes.saldo_correcao.indice_correcao,
        valor_saldo_correcao:
          condicoes && condicoes.saldo_correcao.valor_saldo_correcao,
      },
      valor_lote: {
        porcentagem_desconto:
          condicoes && condicoes.valor_lote.porcentagem_desconto,
        valor_sugerido: condicoes && condicoes.valor_lote.valor_sugerido,
      },
      is_isencao: condicoes && condicoes.isIsencao,
      descricao: condicoes && condicoes.descricao,
    };
  }

  const codigoProspecto = state.prospecto.codigo;
  const codigoFamilia = state.empreendimento.codigo;
  const ativos = Object.values(state.ativosDaTabelaSelecionadaPorCodigo)
    .filter(ativo => state.ativosSelecionados.includes(ativo.codigo))
    .map(ativo => ({
      ...ativo,
      financiamento: state.financiamentos[ativo.codigo].shortForm,
      parcelas_intermediarias: state.financiamentos[
        ativo.codigo
      ].parcelasFinanciamento.filter(x => x.tipo_intermediaria),
      parcelas_em_series: state.financiamentos[
        ativo.codigo
      ].parcelasFinanciamento.filter(x => x.tipo_escadinha),
      parcelas_condicionantes: [
        // W-0981 SetClub: defesa em profundidade (NÃO é o fix). A invariante é
        // que balão 3 mora só em `descontoSetclub` — quem a garante é a
        // reidratação em `carregarPropostaAuxiliar`. Este predicado só impede
        // que uma regressão futura no writer produza payload duplicado.
        ...state.financiamentos[ativo.codigo].parcelasFinanciamento.filter(
          x =>
            x.periodicidade_balao &&
            Number(x.periodicidade_balao) !== PeriodicidadeBalao.SetClube
        ),
        // W-0981 SetClub: parcela de 5% do VV.
        ...(state.financiamentos[ativo.codigo].descontoSetclub
          ? [
              {
                valor_presente:
                  state.financiamentos[ativo.codigo].descontoSetclub.valor,
                valor: state.financiamentos[ativo.codigo].descontoSetclub.valor,
                vencimento:
                  state.financiamentos[ativo.codigo].descontoSetclub.vencimento,
                parcela: 1,
                taxa: 0,
                codigo_intermediaria: null,
                periodicidade_balao: PeriodicidadeBalao.SetClube,
                tipo_parcela_financiamento: 'Condicionante',
              },
            ]
          : []),
      ],
      divisao_comissao: state.divisaoComissao[ativo.codigo],
    }));

  const autorizacao = {
    justificativa: checkoutData.justificativa,
    codigo_usuario: checkoutData.codigoUsuarioAutorizacao,
    senha: checkoutData.senha || checkoutData.contraSenha,
  };

  const sinal = state.sinal.listaFormasDePagamento.map(sinal => {
    const { tipo_parcela, vencimento, valor } = sinal;
    if (tipo_parcela === CHEQUE)
      return {
        vencimento,
        tipo_parcela,
        valor,
        cheque: sinal,
      };
    else if (sinal.tipo_parcela === CARTAO) {
      const { cartao, numero_documento } = sinal;

      if (
        condicoes.status == CondicoesEspeciaisStatus.PendenteDiretoria &&
        cartao &&
        cartao.codigo
      ) {
        return {
          vencimento,
          tipo_parcela,
          valor,
          cartao: {
            codigo: cartao.codigo,
            numero_documento: cartao.numero_documento,
          },
        };
      }
      return {
        vencimento,
        tipo_parcela,
        valor,
        cartao: {
          codigo: cartao || sinal.codigo,
          numero_documento: numero_documento || sinal.numero_documento,
        },
      };
    } else
      return {
        vencimento,
        tipo_parcela,
        valor,
      };
  });

  const sinalMesa = state.sinalMesa.listaFormasDePagamentoImob.map(sinal => {
    const { tipo_parcela, vencimento, valor } = sinal;
    if (tipo_parcela === CHEQUE)
      return {
        vencimento,
        tipo_parcela,
        valor,
        cheque: sinal,
      };
    else if (sinal.tipo_parcela === CARTAO) {
      const { cartao, numero_documento } = sinal;

      if (
        condicoes.status == CondicoesEspeciaisStatus.PendenteDiretoria &&
        cartao &&
        cartao.codigo
      ) {
        return {
          vencimento,
          tipo_parcela,
          valor,
          cartao: {
            codigo: cartao.codigo,
            numero_documento: cartao.numero_documento,
          },
        };
      }
      return {
        vencimento,
        tipo_parcela,
        valor,
        cartao: {
          codigo: cartao || sinal.codigo,
          numero_documento: numero_documento || sinal.numero_documento,
        },
      };
    } else
      return {
        vencimento,
        tipo_parcela,
        valor,
      };
  });

  let request = {
    codigo_familia: codigoFamilia,
    tabela_selecionada: state.tabelaSelecionada,
    autorizacao: autorizacao,
    ativos: ativos,
    sinal: sinal,
    sinal_mesa: sinalMesa,
    data: state.checkout.dataVenda,
    codigo_ponto_venda: checkoutData.codigoPontoVenda,
    codigo_proposta: codigoProposta,
    codigo_construtor: state.construtorSelecionado,
    venda_interna: checkoutData.vendaInterna,
    contrato_digital: checkoutData.contratoDigital,
    condicoes_especiais: condicoesEspeciais,
    contraproposta: checkoutData.contraproposta,
    is_setclub: state.empreendimento && state.empreendimento.is_setclub,
    is_parcelas_nao_concomitantes: isParcelasNaoConcomitantes,
    opcao_recebimento_boletos: checkoutData.opcaoRecebimentoBoletos ? 3 : 1,
  };

  try {
    const response = await api.gravarVenda(
      codigoFamilia,
      codigoProspecto,
      request
    );
    dispatch({
      type: '@vendas/GRAVAR_VENDA_SUCESSO',
      payload: response,
    });
  } catch (err) {
    console.error(err);
    dispatch({
      type: '@vendas/GRAVAR_VENDA_ERRO',
      payload: err.message,
    });
  }
};

export const autorizarVenda = (
  codigoProposta,
  justificativa
) => async dispatch => {
  dispatch({
    type: '@vendas/GRAVANDO_VENDA',
  });

  try {
    const autorizacao = {
      justificativa,
    };
    const response = await api.autorizarVenda(codigoProposta, autorizacao);
    dispatch({
      type: '@vendas/GRAVAR_VENDA_SUCESSO',
      payload: response,
    });
  } catch (err) {
    console.error(err);
    dispatch({
      type: '@vendas/GRAVAR_VENDA_ERRO',
      payload: err.message,
    });
  }
};

export const excluirVenda = codigoProposta => async dispatch => {
  dispatch({
    type: '@vendas/EXCLUINDO_VENDA',
  });

  try {
    const response = await api.excluirPropostaRapidaAuxiliar(codigoProposta);

    dispatch({
      type: '@vendas/EXCLUIR_VENDA_SUCESSO',
      payload: response,
    });
  } catch (err) {
    console.error(err);
    dispatch({
      type: '@vendas/EXCLUIR_VENDA_ERRO',
      payload: err.message,
    });
  }
};

export const criarContraproposta = codigoProposta => async (
  dispatch,
  getState
) => {
  dispatch({
    type: '@vendas/GRAVANDO_VENDA',
  });
  try {
    const response = await api.criarContraproposta(
      codigoProposta,
      getState().vendas.condicoesEspeciais
    );
    dispatch({
      type: '@vendas/GRAVAR_VENDA_SUCESSO_CONTRA_PROPOSTA',
      payload: response,
    });
  } catch (err) {
    console.error(err);
    dispatch({
      type: '@vendas/GRAVAR_VENDA_ERRO',
      payload: err.message,
    });
  }
};
